export const READ_NOTIFICATION_REQUEST = 'notification/READ_REQUEST';
export const READ_NOTIFICATION_SUCCESS = 'notification/READ_SUCCESS';
export const READ_NOTIFICATION_FAILURE = 'notification/READ_FAILURE';

export const readNotificationRequest = () => ({ type: READ_NOTIFICATION_REQUEST });
export const readNotificationSuccess = payload => ({ type: READ_NOTIFICATION_SUCCESS, payload });
export const readNotificationFailure = () => ({ type: READ_NOTIFICATION_FAILURE });

export const readNotification = notificationId => (dispatch, getState, { request }) => {
  dispatch(readNotificationRequest());

  const promise = request.put(`/_api/notifications/${notificationId}/read`, {});
  return promise
    .then(notification => dispatch(readNotificationSuccess(notification)))
    .catch(() => dispatch(readNotificationFailure()))
    .then(() => promise);
};



// WEBPACK FOOTER //
// ./app/actions/read-notification.js